// GNB: 백엔드 code → 라우트 매핑 및 정적 게스트 메뉴 (스토어와 분리된 순수 데이터)

export interface Menu {
  title: string;
  link: string;
  children?: Menu[];
}

/** 백엔드 메뉴 code → 프론트 라우트 경로 (단일 출처) */
export const CODE_TO_ROUTE: Record<api.gnb.menu.childCode, string> = {
  quick: '/outbound/quick',
  parcel: '/outbound/parcel',
  massParcel: '/outbound/mass-parcel',
  mail: '/outbound/registry',
  massMail: '/outbound/mass-registry',
  internationalMail: '/outbound/global',
  outboundTracking: '/tracking/outbound',
  inboundTracking: '/tracking/inbound',
  notice: '/help/notice',
  faq: '/help/faq',
  serviceIntro: '/service',
  clientBenefit: '/client/benefit',
};

/** 비로그인 사용자용 정적 메뉴 — API는 인증 필수라 호출 불가 */
export const STATIC_GUEST_MENU: Menu[] = [
  {
    title: '주문접수',
    link: '/outbound/quick',
    children: [],
  },
  {
    title: '주문조회',
    link: '/tracking/outbound',
    children: [],
  },
  {
    title: '공지사항',
    link: '/help/notice',
    children: [
      { title: '공지사항', link: '/help/notice' },
      { title: 'FAQ', link: '/help/faq' },
    ],
  },
  {
    title: '서비스소개',
    link: '/service',
    children: [
      { title: '서비스소개', link: '/service' },
      { title: '고객혜택', link: '/client/benefit' },
    ],
  },
];
